"use client";

import SeriesCard from "@/components/series-card";
import { Button } from "@/components/shadcn/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/shadcn/card";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { RecommendationsConfig } from "./types";

export function VideoDetailRecommendations({
    title,
    description,
    items,
    moreHref,
    cardVariant,
}: RecommendationsConfig) {
    const t = useTranslations("series");

    if (items.length === 0) {
        return null;
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
                <CardDescription>{description}</CardDescription>
            </CardHeader>
            <CardContent className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {items.map((item) => (
                    <SeriesCard
                        key={item.Id}
                        series={item}
                        variant={cardVariant}
                    />
                ))}
            </CardContent>
            <CardFooter className="justify-center">
                <Button asChild variant="outline">
                    <Link href={moreHref}>{t("seeMore")}</Link>
                </Button>
            </CardFooter>
        </Card>
    );
}
